<template>
  <div class="container">
    <table class="table table-bordered">
      <thead>
        <tr class="thead-light">
          <th colspan="4">Modules</th>
        </tr>
      </thead>
      <tbody class="package-list">
        <tr v-for="pkg in $store.getters.packages" v-bind:key="pkg.id">
          <td>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                class="custom-control-input"
                name="package"
                v-model="$store.state.subscriberData.Package"
                :id="pkg.id"
                :value="pkg.name"
              />
              <label class="custom-control-label" :for="pkg.id">{{pkg.name}}</label>
            </div>
          </td>
          <td class="text-left">
            <label :for="pkg.id" v-html="pkg.description"></label>
          </td>
          <td>&euro; {{pkg.price}}</td>
        </tr>
      </tbody>
    </table>
    <router-link to="/subscribe/study-selection">
      <button class="btn btn-secondary">Back</button>
    </router-link>
    <router-link
      to="/subscribe/experience-center"
      v-if="$store.getters.getOption('experience-center')"
    >
      <button class="btn btn-primary">Next</button>
    </router-link>
    <router-link
      to="/subscribe/career-expo-options"
      v-else-if="$store.getters.hasEvent('career-expo')"
    >
      <button class="btn btn-primary">Next</button>
    </router-link>
    <router-link
      to="/subscribe/interviewing-days-options"
      v-else-if="$store.getters.hasEvent('interviewing-days')"
    >
      <button class="btn btn-primary">Next</button>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "package-selection"
};
</script>

<style lang="scss">
.package-list {
  label {
    display: block;
  }
}
</style>